import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Floating "← Back to Mela admin" pill, shown only when the current AICOS
 * session was bridged from a Mela admin login. Helps the marketing team
 * navigate back to operations without typing the URL.
 *
 * Hidden on Mela admin pages themselves (so it doesn't show up while you're
 * already there).
 */
export default function MelaBridgeIndicator() {
  const { user } = useAuth();

  if (!user?.isMelaBridge) return null;
  if (window.location.pathname.startsWith('/admin/mela')) return null;
  if (window.location.pathname.startsWith('/mela')) return null;

  const back = () => {
    window.location.href = '/admin/mela';
  };

  return (
    <button
      onClick={back}
      style={{
        position: 'fixed',
        bottom: 20,
        right: 20,
        zIndex: 9999,
        padding: '10px 18px',
        background: 'linear-gradient(135deg,#EC4899,#8B5CF6)',
        color: '#fff',
        border: 'none',
        borderRadius: 999,
        fontWeight: 700,
        fontSize: 13,
        cursor: 'pointer',
        fontFamily: "'Plus Jakarta Sans', sans-serif",
        boxShadow: '0 6px 20px rgba(139,92,246,0.4)',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
      }}
      title="Return to Mela admin operations"
    >
      <span>←</span>
      <span>Back to Mela admin</span>
    </button>
  );
}
